import RssApi from '@/api/rss';

export default {
  namespaced: true,

  state: {
    data: {},
    meta: {},
    categories: [],
    loading: false,
    error: null,
  },

  actions: {
    async fetch(ctx, data) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const options = {};
        const response = await RssApi.fetch(options, data.category.id);

        if (!response.cancelled) {
          ctx.commit('setData', response.data.data);
          ctx.commit('setMeta', response.data.meta);
          ctx.commit('setLoading', false);
        }
      } catch (err) {
        ctx.commit('setError', err);
        ctx.commit('setLoading', false);
      }
    },

    async getConfig(ctx) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await RssApi.getConfig();
        ctx.commit('setCategories', response.data.data.categories);
        ctx.commit('setMeta', response.data.meta);
      } catch (err) {
        ctx.commit('setError', err);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async create(ctx, data) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await RssApi.create(data);
        return null;
      } catch (err) {
        ctx.commit('setError', err);
        return err;
      } finally {
        await ctx.dispatch('fetch', data);
        ctx.commit('setLoading', false);
      }
    },

    async save(ctx, data) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await RssApi.update(data);
        return null;
      } catch (err) {
        ctx.commit('setError', err);
        return err;
      } finally {
        await ctx.dispatch('fetch', data);
        ctx.commit('setLoading', false);
      }
    },

    async remove(ctx, data) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await RssApi.remove(data);
        return null;
      } catch (err) {
        ctx.commit('setError', err);
        return err;
      } finally {
        await ctx.dispatch('fetch', data);
        ctx.commit('setLoading', false);
      }
    },
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setCategories(state, data) {
      state.categories = data;
    },

    setData(state, data) {
      state.data = data;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },
  },

  getters: {
    loading: state => state.loading,
    categories: state => state.categories,
    list: state => (state.data.items ? state.data.items : []),
    error: state => state.error,
  },
};
